import { ReactNode, forwardRef } from 'react';
import { cn } from '@/utils';

interface CardWidgetProps {
  children: ReactNode;
  className?: string;
  padding?: boolean;
}

const CardWidget = forwardRef<HTMLDivElement, CardWidgetProps>(
  ({ children, className, padding = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-lg bg-[var(--card-bg)] flex-1',
          padding && 'p-4',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);

CardWidget.displayName = 'CardWidget';

export { CardWidget };
